import { cnNameToTrackData } from './trackData'

export function trackBuild(key: string, config?: any, options?: any) {
  const { element_tag_position, element_data } = config || {}
  const { pagename_cn, element_tag } = cnNameToTrackData[key] || {}

  return {
    element_tag_position,
    element_tag,
    page_data: { ext: { pagename_cn, element_data, track_version: 'v1.0' } }
  }
}

export default trackBuild
